import { BrandProductsListUI } from './BrandProductsListUI'
import { useProductsList } from '../ProductsList/useProductsList'

export const BrandProductsList = () => {
  const productsListProps = useProductsList({ basePath: '/produtos-marca', requireParamKey: 'brand_id' })
  return <BrandProductsListUI {...productsListProps} />
}

export default BrandProductsList
